/* Montanello clone — core behaviour */
(function () {
  'use strict';
  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var money = function (cents) {
    var f = (window.MT && window.MT.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
  };

  /* ---------------- drawers ---------------- */
  var overlay;
  function ensureOverlay() {
    overlay = $('.mt-overlay');
    if (!overlay) {
      overlay = D.createElement('div');
      overlay.className = 'mt-overlay';
      D.body.appendChild(overlay);
    }
    overlay.addEventListener('click', closeDrawers);
  }
  function openDrawer(id) {
    var d = D.getElementById(id);
    if (!d) return;
    closeDrawers(true);
    setTimeout(function () {
      d.classList.add('is-open');
      overlay.classList.add('is-open');
      D.body.style.overflow = 'hidden';
      var f = d.querySelector('input[type=search],input[type=text]');
      if (f && d.id === 'mtSearch') f.focus();
    }, 10);
  }
  function closeDrawers(keepScroll) {
    $$('.mt-drawer').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    if (!keepScroll) D.body.style.overflow = '';
  }
  D.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mt-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-mt-open')); return; }
    if (e.target.closest('[data-mt-close]')) { e.preventDefault(); closeDrawers(); }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- accordions ---------------- */
  D.addEventListener('click', function (e) {
    var h = e.target.closest('.acc__head,.filt__head,.mt-footer__acc>button,[data-mt-acc]');
    if (!h) return;
    e.preventDefault();
    var item = h.closest('.acc,.filt,.mt-footer__acc,[data-mt-acc-item]');
    if (item) item.classList.toggle('is-open');
  });
  /* submenu inside nav drawer */
  D.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mt-sub]');
    if (!t) return;
    e.preventDefault();
    var ul = t.parentElement.querySelector('.mt-nav__sub');
    if (ul) ul.classList.toggle('is-open');
  });

  /* ---------------- hero slideshow ---------------- */
  $$('.hslide').forEach(function (el) {
    var slides = $$('.hslide__slide', el);
    var dots = $$('.hslide__dot', el);
    if (slides.length < 2) return;
    var i = 0, speed = parseInt(el.dataset.speed || '5000', 10), timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); reset(); }); });
    function reset() { clearInterval(timer); if (el.dataset.autoplay === 'true') timer = setInterval(function () { go(i + 1); }, speed); }
    reset();
  });

  /* ---------------- cart ---------------- */
  function refreshCart() {
    var id = window.MT_CART_SECTION;
    var jobs = [
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }),
      id ? fetch('/?sections=' + encodeURIComponent(id), { cache: 'no-store' })
             .then(function (r) { return r.json(); }) : Promise.resolve(null)
    ];
    return Promise.all(jobs).then(function (res) {
      var cart = res[0], sec = res[1];
      if (sec && sec[window.MT_CART_SECTION]) {
        var host = D.getElementById('mtCart');
        var wasOpen = host && host.classList.contains('is-open');
        var tmp = D.createElement('div');
        tmp.innerHTML = sec[window.MT_CART_SECTION];
        var fresh = tmp.querySelector('#mtCart');
        if (host && fresh) {
          host.innerHTML = fresh.innerHTML;
          if (wasOpen) host.classList.add('is-open');
        }
      }
      $$('.js-cart-count').forEach(function (e) { e.textContent = cart.item_count; });
    });
  }
  window.MTrefreshCart = refreshCart;

  function addToCart(id, qty, props) {
    var body = { items: [{ id: id, quantity: qty || 1 }] };
    if (props) body.items[0].properties = props;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Error'); });
      return r.json();
    }).then(function () { return refreshCart(); })
      .then(function () { openDrawer('mtCart'); });
  }
  window.MTaddToCart = addToCart;

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(); });
  }

  D.addEventListener('click', function (e) {
    var r = e.target.closest('[data-mt-remove]');
    if (r) { e.preventDefault(); changeLine(r.getAttribute('data-mt-remove'), 0); return; }
    var q = e.target.closest('[data-mt-qty]');
    if (q) {
      e.preventDefault();
      var wrap = q.closest('.mt-qty');
      var inp = wrap.querySelector('input');
      var v = parseInt(inp.value, 10) || 1;
      v = q.getAttribute('data-mt-qty') === 'up' ? v + 1 : Math.max(0, v - 1);
      changeLine(inp.getAttribute('data-key'), v);
    }
  });
  D.addEventListener('change', function (e) {
    var inp = e.target.closest('.mt-qty input[data-key]');
    if (inp) changeLine(inp.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0));
  });

  /* ---------------- product form ---------------- */
  function initProduct(root) {
    var data = JSON.parse($('[data-mt-variants]', root).textContent);
    var opts = JSON.parse($('[data-mt-options]', root).textContent);
    var sel = opts.map(function (o) { return o.selected; });
    var priceEl = $('[data-mt-price]', root);
    var wasEl = $('[data-mt-was]', root);
    var btn = $('[data-mt-atc]', root);
    var idInput = $('[data-mt-vid]', root);
    var gallery = $('.pdp__gallery');
    var baseOrder = gallery ? $$('img', gallery) : [];
    var dots = $$('.pdp__dots i');

    function find() {
      return data.find(function (v) {
        return v.o.every(function (val, i) { return sel[i] == null || val === sel[i]; });
      });
    }
    function render() {
      opts.forEach(function (o, i) {
        $$('[data-mt-opt="' + i + '"]', root).forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-mt-val') === sel[i]);
        });
        var lab = $('[data-mt-oplabel="' + i + '"]', root);
        if (lab) lab.textContent = o.name.toUpperCase() + ' : ' + (sel[i] || '');
      });
      /* mark sold-out sizes for the chosen colour */
      if (opts.length > 1) {
        $$('[data-mt-opt="1"]', root).forEach(function (b) {
          var val = b.getAttribute('data-mt-val');
          var m = data.find(function (v) { return v.o[0] === sel[0] && v.o[1] === val; });
          b.classList.toggle('is-soldout', !m || !m.a);
        });
      }
      var v = find();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) { priceEl.textContent = money(v.p); priceEl.classList.toggle('pdp__price--plain', !v.c); }
      if (wasEl) { wasEl.textContent = v.c ? money(v.c) : ''; wasEl.style.display = v.c ? '' : 'none'; }
      if (btn) {
        btn.disabled = !v.a;
        btn.classList.toggle('is-disabled', !v.a);
        btn.textContent = v.a ? 'ADD TO CART' : 'SOLD OUT';
      }
      /* Match the source: hoist the selected colour's photo to the first gallery
         slot, keep every other image in its original order, and never scroll. */
      if (gallery && baseOrder.length) {
        var lead = null;
        if (v.m != null) {
          lead = baseOrder.filter(function (im) {
            return im.getAttribute('data-media-index') === String(v.m);
          })[0] || null;
        }
        var order = lead ? [lead].concat(baseOrder.filter(function (im) { return im !== lead; }))
                         : baseOrder.slice();
        var changed = order.some(function (im, i) { return gallery.children[i] !== im; });
        if (changed) {
          var frag = D.createDocumentFragment();
          order.forEach(function (im) { frag.appendChild(im); });
          gallery.appendChild(frag);
          gallery.scrollLeft = 0;                    /* mobile carousel back to slide 1 */
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === 0); });
        }
      }
      try {
        var u = new URL(window.location);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      } catch (e) {}
    }
    $$('[data-mt-opt]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        sel[parseInt(b.getAttribute('data-mt-opt'), 10)] = b.getAttribute('data-mt-val');
        render();
      });
    });
    render();

    var form = $('[data-mt-form]', root);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = find();
      if (!v || !v.a) return;
      btn.textContent = 'ADDING…';
      addToCart(v.id, 1).then(function () { btn.textContent = 'ADD TO CART'; })
        .catch(function (err) { btn.textContent = 'ADD TO CART'; alert(err.message); });
    });
  }
  $$('[data-mt-product]').forEach(initProduct);

  /* complementary / upsell: swap thumbnail + price when a dropdown changes */
  function cmpSync(form) {
    var map = JSON.parse($('[data-mt-cmpmap]', form).textContent);
    var vals = $$('select', form).map(function (s) { return s.value; });
    var hit = map.find(function (v) { return v.o.join('|') === vals.join('|'); });
    if (!hit) return null;
    var img = $('[data-mt-cmpimg]', form);
    if (img && hit.img) { img.removeAttribute('srcset'); img.src = hit.img; }
    var pr = $('[data-mt-cmpprice]', form), was = $('[data-mt-cmpwas]', form);
    if (pr) { pr.textContent = money(hit.p); pr.classList.toggle('pcard__price--plain', !hit.c); }
    if (was) { was.textContent = hit.c ? money(hit.c) : ''; was.style.display = hit.c ? '' : 'none'; }
    return hit;
  }
  D.addEventListener('change', function (e) {
    var f = e.target.closest('[data-mt-cmp]');
    if (f && e.target.tagName === 'SELECT') cmpSync(f);
  });

  /* complementary / upsell add */
  D.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-mt-cmp]');
    if (!f) return;
    e.preventDefault();
    var hit = cmpSync(f);
    var b = f.querySelector('button');
    if (!hit) { return; }
    var old = b.textContent; b.textContent = 'ADDING…';
    addToCart(hit.id, 1).then(function () { b.textContent = old; })
      .catch(function (err) { b.textContent = old; alert(err.message); });
  });

  /* ---------------- PLP controls ---------------- */
  var grid = $('.plp__grid');
  $$('[data-mt-cols]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = b.getAttribute('data-mt-cols');
      grid.style.setProperty('--plp-cols', n);
      $$('[data-mt-cols]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      try { localStorage.setItem('mt-cols', n); } catch (e) {}
    });
  });
  try {
    var saved = localStorage.getItem('mt-cols');
    if (saved && grid) {
      grid.style.setProperty('--plp-cols', saved);
      $$('[data-mt-cols]').forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-mt-cols') === saved); });
    }
  } catch (e) {}
  var sortSel = $('[data-mt-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location);
    u.searchParams.set('sort_by', sortSel.value);
    u.searchParams.delete('page');
    window.location = u.toString();
  });
  $$('[data-mt-filterform]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });
  var fb = $('[data-mt-filters-toggle]');
  if (fb) fb.addEventListener('click', function () { $('.plp__side').classList.toggle('is-open'); });
  var fc = $('[data-mt-filters-close]');
  if (fc) fc.addEventListener('click', function () { $('.plp__side').classList.remove('is-open'); });

  /* ---------------- predictive search ---------------- */
  var si = $('[data-mt-searchinput]');
  if (si) {
    var box = $('[data-mt-searchresults]'), t;
    si.addEventListener('input', function () {
      clearTimeout(t);
      var q = si.value.trim();
      if (q.length < 2) { box.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=mt-predictive')
          .then(function (r) { return r.text(); })
          .then(function (h) {
            var tmp = D.createElement('div'); tmp.innerHTML = h;
            var inner = tmp.querySelector('[data-mt-predictive]');
            box.innerHTML = inner ? inner.innerHTML : '';
          });
      }, 220);
    });
  }

  /* play creator-gallery videos only while visible */
  (function () {
    var vids = $$('.cgal__video, .cgal video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.play().catch(function () {}); }
        else { en.target.pause(); }
      });
    }, { rootMargin: '100px' });
    vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); io.observe(v); });
  })();

  /* mobile PDP gallery dots */
  (function () {
    var g = $('.pdp__gallery'), dots = $$('.pdp__dots i');
    if (!g || !dots.length) return;
    var t;
    g.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(g.scrollLeft / g.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, 60);
    });
  })();

  ensureOverlay();
})();
